import { Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { HttpClient } from "@angular/common/http";

export interface IBlockchain
{
    id: number;
    name: string;
    full_name: string;
    platform: string;
    platformMain: any;
    chain_id: number;
    explorer: string;
    icon?: string;
    testnet: boolean;
    token_standard?: string;
    network?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class BlockchainApi
{

    constructor(
        private storage: StorageService,
        private http: HttpClient
    ) { }

    //Gets all blockchain
    public async getAll(): Promise<IBlockchain[]>
    {
        try
        {
            return <IBlockchain[]>await this.http.get('/api/blockchain').toPromise();
        }
        catch (error)
        {
            return [];
        }
    }
    public async getByPlatform(_platform: string): Promise<IBlockchain[]>
    {
        try
        {
            return <IBlockchain[]>await this.http.get(`/api/blockchain/by-platform/${ _platform }`).toPromise();
        }
        catch (error)
        {
            return [];
        }
    }
}
